import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll: function(example, pageable) {
    let params = utils.merge(example, pageable);
    return httpService.get("role", { params: params });
  },
  findAllRole(form, pageable) {
    let params = utils.merge(form, pageable);
    return httpService.get("roleInfo/findAll", {params: params});
  },
  findById(id) {
    return httpService.get("roleInfo/" + id);
  },
  update(id, form) {
    return httpService.put(`/roleInfo/${id}`, form);
  },
  save(form) {
    return httpService.post(`/roleInfo`, form);
  },
  delete(id) {
    return httpService.delete("/roleInfo/" + id);
  }
};



// WEBPACK FOOTER //
// ./src/services/roleService.js